import { useEffect } from "react";

/**
 * Discourages casual image downloading by blocking:
 * - Right-click context menu on <img> elements
 * - Drag-to-save on <img> elements
 * - Ctrl/Cmd+S page-save shortcut
 *
 * Note: Determined users can still capture images via DevTools or screenshots.
 * This only blocks the common cases without affecting normal UX (text selection,
 * right-click on links/buttons, etc. still work).
 */
export function useImageProtection() {
  useEffect(() => {
    const isImage = (target: EventTarget | null): target is HTMLImageElement =>
      target instanceof HTMLImageElement;

    const onContextMenu = (e: MouseEvent) => {
      if (isImage(e.target)) e.preventDefault();
    };

    const onDragStart = (e: DragEvent) => {
      if (isImage(e.target)) e.preventDefault();
    };

    const onKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", onContextMenu);
    document.addEventListener("dragstart", onDragStart);
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("contextmenu", onContextMenu);
      document.removeEventListener("dragstart", onDragStart);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);
}
